import * as yup from "yup";
import { DownsellType } from "../../context/use-downsell-flow/use-downsell-flow.types";

export const BookingDownsellSchema = yup.object().shape({
  downsell_type: yup
    .string()
    .oneOf([
      "booking-and-cycle",
      "booking-and-next-bookings-and-cycles",
      "booking-only",
      "booking-and-next-bookings",
    ] as DownsellType[])
    .required("Selecione uma opção de cancelamento."),
});
